import {createSlice} from "@reduxjs/toolkit";

const initialNewPaidListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  contestData: [], 
  contestUsers: [], 
  retentionreportlist: [],
  gameList: [],
  gameTypeList: [],
  company: [],
  country: [],
  upload: {},
  imageField : undefined,
  screenShots: [], 
  totalJoinedPlayers: 0,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const NewPaidList = createSlice({
  
  name: "newPaidList",
  initialState: initialNewPaidListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    contestListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice",totalCount, entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
     joinpaidgameExport: (state, action) => {
      const { exportData} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
      //state.totalCount = totalCount;
    },
      CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      //state.listLoading = false;
      state.error = null;
      state.companyDropdownList = companyDropdownList;
     // state.totalCount = totalCount;
    },
  
  }
});


